import { useTheme } from "@amx/ux-twoui-theming";
import React, { useContext } from "react";
import { getRTLIcon } from "../../../../styles/language";
import { DrawerContext } from "../../DrawerBase/DrawerBase";
import { getChevronIconStyles } from "./DrawerHeaderChevron.styles";

export type ChevronPosition = "start" | "end";

export interface DrawerHeaderChevronProps {
    /**
     * Chevron position inside the drawer header. Default value is to render at the start.
     */
    readonly chevronPosition?: ChevronPosition;
}

export const DrawerHeaderChevron: React.FC<DrawerHeaderChevronProps> = ({
    chevronPosition = "start"
}) => {
    const context = useContext(DrawerContext);
    const theme = useTheme();

    const chevronIconName = chevronPosition === "start" ? getRTLIcon("ChevronRightMed") : "ChevronDownMed";

    return (
        // Using Fluent Icon directly to be able to specify the animation styles
        <span
            role={"presentation"}
            data-icon-name={chevronIconName}
            className={chevronIconName}
            style={getChevronIconStyles(theme, context.drawerOpen, chevronPosition)}
        />
    );
};
